<div class="container">
    <div class="header">
        <div class="header-content">
            <span class="titulo">VER ESTABLECIMIENTO</span>
        </div>
        <span class="header-text font14">Formulario con los datos de un establecimientos DataBeer</span>
    </div>
    <div class="body">

        <div class="datos-dispositivo">

            <!--DISPOSITIVO-->

            <div class="datos-dispositivo-header">
                <span>DATOS DEL ESTABLECIMIENTO</span>
            </div>

            <mat-form-field class="etiqueta-container marginTop30" appearance="outline">
                <mat-label class="label-text">Identificador</mat-label>
                <input matInput type="text" [(ngModel)]="identificador" placeholder="Identificador único del usuario" 
                value="{{this.establecimientoActual.dev_label}}" [readonly]="true">
            </mat-form-field>

            <mat-form-field appearance="outline" class="widht100">
                <mat-label class="label-text">Etiqueta</mat-label>
                <input matInput type="text" [(ngModel)]="etiqueta" placeholder="Nombre de una localidad, parroquia, nucleo, etc..." 
                value="{{this.establecimientoActual.dev_label}}" [readonly]="true">
            </mat-form-field>
             
            <mat-form-field appearance="outline" class="widht100" *ngIf="userData.pro_id == 4">
                <mat-label class="label-text">Cliente</mat-label>
                <input matInput type="text" value="{{clienteDelEstablecimiento}}" [readonly]="true">
            </mat-form-field>

            <div class="marinTop10menos">
                <span class="titulos-dispositivo">Cerveza: </span> <span> Tipos de cerveza</span>
                <mat-form-field class="etiqueta-container margin0" appearance="outline">
                    <input matInput type="text" [value]="obtenerNombresDeCervezas()" [readonly]="true">
                </mat-form-field>
            </div>

            <div class="marinTop20menos">
                <mat-form-field class="etiqueta-container" appearance="outline">
                    <mat-label class="label-text">Estado:</mat-label>
                    <input matInput type="text" [value]="obtenerNombreEstado(selectedEstado)" [readonly]="true">
                </mat-form-field>
            </div>

            <!--DATOS DE CONTACTO-->

            <div class="datos-contacto-header">
                <span>DATOS DE CONTACTO</span>
            </div>

            <form [formGroup]="signin">
                <mat-form-field class="etiqueta-container marginTop20" appearance="outline">
                    <mat-label class="label-text">Contacto</mat-label>
                    <input matInput type="text" formControlName="contacto" [readonly]="true">
                </mat-form-field>
            </form>

            <form [formGroup]="signin">
                <mat-form-field class="input-container2 widht100" appearance="outline">
                    <mat-label class="label-text">Teléfono</mat-label>
                    <input matInput formControlName="telefono" mask="000 00 00 00" [readonly]="true">
                    <mat-icon matPrefix>phone</mat-icon>
                </mat-form-field>
            </form>

            <form [formGroup]="signin">
                <mat-form-field class="input-container2 widht100" appearance="outline">
                    <mat-label class="label-text">Correo electrónico</mat-label>
                    <input matInput formControlName="email" [readonly]="true">
                </mat-form-field>
            </form>

            <div>
                <span class="titulos-dispositivo">Imagen del establecimiento: </span> <span  *ngIf="est_img_path === ''">No encontrada</span>
                <img *ngIf="est_img_path !== ''" src={{est_img_path}} alt="Vista previa de imagen establecimiento" class="imagen-dispositivo">
                <div *ngIf="est_img_path === ''" class="imagen">
                    <img src="assets/images/icons8-not-found-96.png">
                </div>
            </div>

        </div>

        <div class="datos-instalacion">

            <!--UBICACIÓN-->

            <div class="datos-instalacion-header">
                <span>UBICACIÓN DEL ESTABLECIMIENTO</span>
            </div>

            <div class="mapa-container marginTop30">
                <!--<agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" [mapTypeControl]="true" mapTypeId="hybrid">
                    <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker>
                </agm-map>-->
                <div id="map" class="height"></div>
            </div>

            <div class="referencia-container marginTop20">
                <span class="titulo-custom">Dirección completa: </span>
                <mat-form-field appearance="outline" class="latitud-value marginTop10">
                    <input matInput type="text" [readonly]="true" value="{{addressData}}"/>
                </mat-form-field>
            </div>

            <mat-form-field class="lat-container widht48" appearance="outline">
                <mat-label class="label-text">Latitud</mat-label>
                <input matInput type="number" [(ngModel)]="lat" placeholder="Selecciona la latitud" value="{{lat}}" [readonly]="true">
            </mat-form-field>

            <mat-form-field class="lng-container custom" appearance="outline">
                <mat-label class="label-text">Longitud</mat-label>
                <input matInput type="number" [(ngModel)]="lng" placeholder="Selecciona la latitud" value="{{lng}}" [readonly]="true">
            </mat-form-field>

        </div>

        <!--DISPOSITIVOS-->

        <div class="acceso-usuarios">
            <div class="acceso-usuarios-header">
                <span>DISPOSITIVOS DEL ESTABLECIMIENTO</span>
            </div>

            <div class="top-container custom2">
                <mat-form-field>
                    <mat-label class="negro">Filtrar</mat-label>
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Ex.nombre" #input>
                </mat-form-field>
            </div>

            <div class="tabla">
                <table mat-table [dataSource]="dataSource" matSort #sort1="matSort">
                    <ng-container matColumnDef="dev_reference">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Referencia </th>
                        <td mat-cell *matCellDef="let element" class="dev-reference"> {{element.dev_reference}} </td>
                    </ng-container>

                    <ng-container matColumnDef="dev_label">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
                        <td mat-cell *matCellDef="let element"  class="router-cell" routerLink="/dispositivo/ver/{{element.id}}"> {{element.dev_label}} </td>
                    </ng-container>

                    <ng-container matColumnDef="clientId" *ngIf="userData.pro_id == 4">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cliente</th>
                        <td mat-cell *matCellDef="let element" class="cell"> {{ element.clientId }} </td>
                    </ng-container>

                    <ng-container matColumnDef="dev_create_at">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha de alta </th>
                        <td mat-cell *matCellDef="let element" class="cell"> {{element.dev_create_at}} </td>
                    </ng-container>
        
                    <ng-container matColumnDef="operaciones">
                        <th mat-header-cell *matHeaderCellDef> Operaciones </th>
                        <td mat-cell *matCellDef="let element">
                          <div class="button-container">
                            <button mat-mini-fab class="ver-btn" matTooltip="Ver dispositivo" aria-label="Ver establecimiento" routerLink="/dispositivo/ver/{{element.id}}">
                              <mat-icon>remove_red_eye</mat-icon>
                            </button>
                            <button mat-mini-fab *ngIf="userData.pro_id == 4 || userData.pro_id == 1 " class="edit-btn" matTooltip="Editar dispositivo" aria-label="Editar establecimiento" routerLink="/{{element.id}}/editar/dispositivo">
                              <mat-icon>edit</mat-icon>
                            </button>
                          </div>
                        </td>
                      </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <mat-paginator #paginator1
                    [pageSizeOptions]="[10,20,40]" 
                    showFirstLastButtons 
                    aria-label="Elige una página"
                    class="paginatorCustom">
                </mat-paginator>
            </div>
        </div>

        <!--RECARGAS-->

        <div class="acceso-usuarios">
            <div class="acceso-usuarios-header">
                <span>RECARGAS DE TANQUES EN EL ESTABLECIMIENTO</span>
            </div>

            <div class="top-container custom2">
                <mat-form-field>
                    <mat-label class="negro">Filtrar</mat-label>
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput (keyup)="applyFilterRecargas($event)" placeholder="Ex.nombre" #input>
                </mat-form-field>
            </div>

            <div class="tabla">
                <table mat-table [dataSource]="dataSourceRecargas" matSort #sort2="matSort">
                    <ng-container matColumnDef="tank_num">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Num. de Tanque </th>
                        <td mat-cell *matCellDef="let element" class="dev-reference"> {{element.tank_num}} </td>
                    </ng-container>
        
                    <ng-container matColumnDef="dev_reference">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Ref. Dispositivo </th>
                        <td mat-cell *matCellDef="let element" class="cell"> {{element.dev_reference}} </td>
                    </ng-container>
        
                    <ng-container matColumnDef="dev_label">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre Disp. </th>
                        <td mat-cell *matCellDef="let element" class="router-cell" routerLink="/dispositivo/ver/{{element.dev_id}}"> {{element.dev_label}} </td>
                    </ng-container>
        
                    <ng-container matColumnDef="f_inicio">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> F. de Recarga </th>
                        <td mat-cell *matCellDef="let element" class="cell"> {{element.f_inicio}} </td>
                    </ng-container>
        
                    <ng-container matColumnDef="litres_input">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Introducidos (L)</th>
                        <td mat-cell *matCellDef="let element" class="cell alignRight"> {{element.litres_input}} </td>
                    </ng-container>
        
                    <ng-container matColumnDef="litres_output">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Retirados (L) </th>
                        <td mat-cell *matCellDef="let element" class="cell alignRight"> {{element.litres_output}} </td>
                    </ng-container>
        
                    <ng-container matColumnDef="output_type">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo </th>
                        <td mat-cell *matCellDef="let element" class="cell"> {{element.output_type}} </td>
                    </ng-container>
        
                    <ng-container matColumnDef="beertype">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cerveza </th>
                        <td mat-cell *matCellDef="let element" class="cell"> {{element.beertype}} </td>
                    </ng-container>
                
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsRecargas"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsRecargas;"></tr>
                </table>
                <mat-paginator #paginator2
                    [pageSizeOptions]="[10,20,40]" 
                    showFirstLastButtons 
                    aria-label="Elige una página"
                    class="paginatorCustom">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>
<div class="footer"></div>
